import {
  type CalendarDate,
  calendarDateInTimeZone,
  parseCalendarDate,
} from '@shared/dates/calendarDate';

/**
 * RRULE's Date parser maps years 00–99 into 1900–1999. Read the written UTC
 * calendar components before that coercion; retain the library fallback for
 * other supported representations. The shared parser validates the date.
 */
export function recurrenceUntilCalendarDate(rule: string, parsedUntil: Date): CalendarDate {
  const match = /(?:^|[;:])UNTIL=(\d{4})(\d{2})(\d{2})(?:T\d{6}Z?)?(?=;|\s|$)/.exec(rule);
  if (match) {
    const date = parseCalendarDate(`${match[1]}-${match[2]}-${match[3]}`);
    if (!date) throw new RangeError('Invalid recurrence end date');
    return date;
  }
  return calendarDateInTimeZone(parsedUntil, 'UTC');
}
